<template>
  <b-modal id="bv-modal-translation"
           @hide="onHide"
           @ok="onOk"
           :ok-disabled="!result || inProgress"
           :ok-variant="okVariant"
           :cancel-variant="cancelVariant"
  >
    <template v-slot:modal-title>
      {{$tr("translationDialog.translate","Translate")}}
    </template>
    <b-container class="px-0 mx-0" fluid="true">
      <b-row>
        <b-col>
          <b-form-group label-cols="12" class="text-left" :label="$tr('translationDialog.from','From')" label-for="line-input-dialog-lang-from">
            <b-form-select id="line-input-dialog-lang-from" v-model="fromLang" :options="languages"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-cols="12" class="text-left" :label="$tr('translationDialog.to','To')" label-for="line-input-dialog-lang-to">
            <b-form-select id="line-input-dialog-lang-to" v-model="toLang" :options="languages"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-cols="12" class="text-left" :label="$tr('translationDialog.inputText','Input text')" label-for="line-input-dialog-inp">
            <b-form-textarea
                id="line-input-dialog-inp" v-model="input" :maxlength="maxLength"
                :placeholder="tr('enterSomething','Enter something...')"
                rows="3"
                max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col style="height: 85px" class="text-center">
          <loading v-if="inProgress"></loading>
          <b-button v-else variant="outline-primary" class="mt-5" @click="translate">
            {{$tr("translate","Translate")}} <font-awesome-icon icon="language" transform="" ></font-awesome-icon>
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-cols="12" class="text-left" :label="$tr('translationDialog.TranslatedText','Translated text')" label-for="line-out-dialog-inp">
            <b-form-textarea
                id="line-out-dialog-inp" v-model="result"
                rows="3"
                max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>

</template>

<script>
import ValidatedField from "@/validation/ValidatedField";
import Loading from "@/components/layout/Loading.vue";
import Rpc from "@/Rpc";
import tr from "@/utils/Tr";


export default {
  name: "TranslationDialog",
  components: {Loading},
  async beforeMount() {
  },
  mounted() {
    this.reset();
  },
  methods: {
    tr,

    async onOk(ev) {
      if (this.resolve != null) {
        this.resolve(this.result);
        this.resolve = null;
      }
    },
    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve(null);
        this.resolve = null;
      }
    },

    translate(){
      if(!this.input) {
        this.result = "";
      }

      this.inProgress = true;
      Rpc.Regions.translate(this.fromLang, this.toLang, this.input).lock().then((res => {
        this.result = res;
        this.inProgress = false;
      })).catch(e => {
        console.error(e);
        this.result = "-";
        this.inProgress = false;
      });
    },

    reset(options = {}) {
      this.result = null;
      this.resolve = null;
      this.input = options.input ?? "";
      this.result = "";
      this.fromLang = options.fromLang ?? SessionManager.defaultCustomerLanguageCode;
      this.toLang = options.toLang ?? 'de';
      this.inProgress = false;

      if(this.input && options.toLang && options.fromLang){
       this.translate();
      }
    },
  },

  data: function(){
    let langs = [];
    for(let lang of SessionManager.regionsConfig.allLanguages){
      langs.push({
        value: lang.code,
        text: lang.enName
      });
    }

    return {
      resolve: null,
      result: null,
      fromLang: 'en',
      toLang: 'de',
      okVariant: 'plm-primary',
      cancelVariant: 'plm-secondary',
      maxLength: 2000,
      input: "",
      inProgress: false,
      languages: langs
    };
  }
}
</script>
